import axios from 'axios';
import sha256 from 'js-sha256';
import FormData from 'form-data';
//import requestIp from 'request-ip';

// const DEFAULT_HOST = 'http://10.100.26.134:36100'; // 本地
//const DEFAULT_HOST = 'https://app-api.zjol.com.cn'; // 正式环境
//const DEFAULT_HOST = 'https://apibeta.zjol.com.cn'; // 测试环境
// const DEFAULT_HOST = 'https://apiprev.zjol.com.cn'; // 预发布环境
const DEFAULT_HOST = '/tm';

function generateSignatureHeader(url) {
  const timestamp = Date.now();
  const sigKey = 'opj!89#%$kddd';
  const sig = sha256(
    `${url}||111111111111111111111111||01c47915-4777-11d8-bc70-0090272ff725||${timestamp}||${sigKey}`
  ).toString();
  return {
    'X-SESSION-ID': '111111111111111111111111',
    'X-REQUEST-ID': '01c47915-4777-11d8-bc70-0090272ff725',
    'X-SIGNATURE': sig,
    'X-TIMESTAMP': timestamp,
  };
}

async function fetch({
  context = { req: {} },
  method,
  url,
  data = {},
  client = true,
  clientSignature = {},
}) {
  //console.log(`MAKING FETCH: ${method}: ${url} BY: ${client ? 'client' : 'server'}`);
  /*
  const ip = requestIp.getClientIp(context.req);
  const reqHeaders = context.req.headers || {};
  const uaHeader = {
    //'User-Agent': 'zjolapp; 5.0.0; zjolapp_PORTAL_ID; NULL; NULL; NULL; NULL; NULL',
    'X-Forwarded-for': ip || '',
    'X-Real-Ip': ip || '',
    //Cookie: reqHeaders.cookie || '',
  };
  const sigHeaders = client ? clientSignature : generateSignatureHeader(url);
  */
  const settings = { method, headers: { ...generateSignatureHeader(url) } };
  if (method.toLowerCase() === 'get') {
    settings.params = data;
  } else if (method.toLowerCase() === 'post') {
    const formData = new FormData();
    // eslint-disable-next-line array-callback-return
    Object.keys(data).map((key) => {
      formData.append(key, data[key]);
    });
    settings.data = formData;
    //settings.headers = { ...settings.headers, ...formData.getHeaders() };
    //settings.headers = { ...settings.headers };
  }
  const host = DEFAULT_HOST;
  let res;
  try {
    res = await axios(`${host}${url}`, settings);
  } catch (e) {
    console.error(e);
    res = { data: { code: -1, message: e.message || JSON.stringify(e) } };
  }
  return res.data;
}

export default fetch;
